import KfzModelEdit from "../components/KfzModelEdit";
import {connect} from "react-redux";
import {isOnline} from "../actions/userActions";
import {deleteKfzModel, fetchKfzList, fetchKfzModels, updateKfzModel} from "../actions/kfzActions";
import {push} from "react-router-redux";
import {showSnackbar} from "../actions/snachbarActions";
import isFunc from 'lodash/isFunction';
import {makeRoute, ROUTE_KFZ_EDIT} from "../routes";

const m2s = (state, props) => {
	let {kfz_id, hsn, tsn} = props.match.params;
	kfz_id = Number(kfz_id);
	const kfz = state.kfz.list.find(car => car.kfz_id === kfz_id);
	const model = kfz && kfz.models ? kfz.models.find(m => m.tsn === tsn && m.hsn === hsn) : null;
	return {
		kfz,
		model
	};
};

const m2d = (dispatch, props) => {
	let {kfz_id} = props.match.params;
	kfz_id = Number(kfz_id);
	dispatch(isOnline(() => {
		dispatch(fetchKfzList(kfz_id, false, () => {
			dispatch(fetchKfzModels(kfz_id))
		}));
	}));
	return {
		push: to => dispatch(push(to)),
		onSave: (kfz_id, model, onSuccess) => dispatch(updateKfzModel(model, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.model.updated'));
		})),
		onDelete: (kfz, hsn, tsn, onSuccess) => dispatch(deleteKfzModel(kfz, hsn, tsn, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.model.deleted'));
			dispatch(push(makeRoute(ROUTE_KFZ_EDIT, {kfz_id})));
		}))
	};
};

export default connect(m2s, m2d)(KfzModelEdit);


// WEBPACK FOOTER //
// ./src/containers/KfzModelEditController.js